import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToHash from './components/ScrollToHash';

// Pages
import HomePage from './pages/HomePage';
import CompyzPage from './pages/CompyzPage';
import BeatClickerPage from './pages/BeatClickerPage';
import FixscopePage from './pages/FixscopePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToHash />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/apps/compyz" element={<CompyzPage />} />
            <Route path="/apps/beat-clicker" element={<BeatClickerPage />} />
            <Route path="/apps/fixscope" element={<FixscopePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
